export default "__VITE_ASSET__Dv9YG7RT__"